module.exports = "<uch></uch>\r\n<head-title params='title:\"安全客户端管理\"'></head-title>\r\n<client-list></client-list>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/clientManager/index.html
// module id = 249
// module chunks = 0